import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationRootComponent } from './registration-root/registration-root.component';
import { RegistrationFailedComponent } from './registration-failed/registration-failed.component';
import { RegistrationLandingComponent } from './subcomponents/registration-landing/registration-landing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VerificationQuestionComponent } from './subcomponents/verification-question/verification-question.component';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationSuccessComponent } from './registration-success/registration-success.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [
    RegistrationRootComponent,
    RegistrationFailedComponent,
    RegistrationLandingComponent,
    VerificationQuestionComponent,
    RegistrationSuccessComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbInputDatepicker,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [provideNgxMask()]
})
export class RegistrationModule {}
